import gql from 'graphql-tag';
import React, { createContext, ReactNode } from 'react';

import { VariantContextThemesQuery, Wws_FamilyThemeVariant } from './generated/graphql';
import useThemes from './wws-onboarding/helpers/useThemes';

export const flipperExperimentBucketAssignmentQuery = gql`
  query flipperExperimentBucketAssignmentQuery(
    $flipperExperimentBucketId: String!
    $flipperExperimentBucketExperimentId: String!
  ) {
    flipperExperimentBucketAssignment(
      bucketId: $flipperExperimentBucketId
      experimentId: $flipperExperimentBucketExperimentId
    ) {
      bucketing_id
      variant_name
    }
  }
`;

export const membershipQuery = gql`
  query VariantContextMembershipQuery {
    member {
      id
      firstName
      lastName
      fianceFirstName
      fianceLastName
      email
      legacyUserId
      username
    }
  }
`;

export const themesQuery = gql`
  query VariantContextThemesQuery($variant: WWS_FamilyThemeVariant) {
    familyThemes(variant: $variant) {
      family
      themes {
        active
        designerUrl
        family
        id
        mobilePreviewImage {
          mediaApiId
        }
        name
        previewImage {
          mediaApiId
        }
        swatchImage {
          mediaApiId
        }
        stationaryPreviewImage {
          mediaApiId
        }
        themeDesigner {
          companyName
          name
        }
        previewUrl
      }
    }
  }
`;

type FamilyTheme = VariantContextThemesQuery['familyThemes'][0];

const VariantContext = createContext<{
  variant: Wws_FamilyThemeVariant;
  noTheme?: FamilyTheme;
  themes: VariantContextThemesQuery['familyThemes'];
  experimentId?: string;
  loading: boolean;
}>({ variant: Wws_FamilyThemeVariant.Random, noTheme: undefined, themes: [], loading: true });

interface Props {
  children: ReactNode | ReactNode[];
}

export const RANDOM = 'random';
export const LITE_SITE_VARIANT = 'lite-site';
export const CONTROL_VARIANT = 'lite-site-control';
export const DATA_TRAINING_VARIANT = 'data training';
export const EXPERIMENT_ID = 'lite site';

export const VariantProvider: React.FC<Props> = ({ children }) => {
  const { loading, themes: themesData } = useThemes();

  return (
    <VariantContext.Provider
      value={{
        variant: Wws_FamilyThemeVariant.Random,
        themes: (themesData as VariantContextThemesQuery['familyThemes']) || [],
        experimentId: EXPERIMENT_ID,
        loading,
      }}
    >
      {children}
    </VariantContext.Provider>
  );
};

export default VariantContext;
